
<mat-toolbar>
  <mat-toolbar-row>
    <div id="imgHub">
      <img src="assets/images/ralarsa-logo-claro.png">
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<div style="display: flex;flex-flow: column;">

  <div id="grid-hub">
    <div id="contenedor-carga">
      <mat-spinner style="margin:5em auto;"></mat-spinner>
    </div>
    <div *ngFor="let modul of modulos">
      <button  class="btnHub" [style.background]="'url(' + modul.imageUrl + ')'" [routerLink]="[modul.url]"></button>    
    </div>  
  </div>
  <div id="btn-sesion-container">
    <button class="btnCerrar" (click)="logout()">Cerrar sesión</button>
  </div>
</div>
